import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import Loading from "../../Components/loading";
import toast from "react-hot-toast";
import { FaSave } from "react-icons/fa";
import { useSearchParams } from "react-router-dom";

const CreatePositionTab = ({
  formData,
  setFormData,
  errors,
  setErrors,
  setJD,
  setPosition,
  setMinExperience,
  setMaxExperience,
  setTechnologies,
  isPreviousClicked,
  jD,
  setIsSaved,
  setJobId,
  jobId,
  isSaveClicked,
  setIsSaveClicked,
}) => {
  const [jobDescription, setJobDescription] = useState();
  const [jobDescriptionLoader, setJobDescriptionLoader] = useState(false);
  const [apiCall, setApiCall] = useState(1);
  const [saved, setShowSaved] = useState(false);
  const [searchParams] = useSearchParams();
  const userID = searchParams.get("user_id");

  useEffect(() => {
    const storedJD = localStorage?.getItem("jobDescription");
    if (storedJD && isPreviousClicked) {
      setJobDescription(storedJD);
      setJD(storedJD);
    } else {
      const defaultJD = `Job Title: React & Node.js Developer\n\nKey Responsibilities:\n\n- Develop and maintain scalable web applications using React and Node.js. \n- Collaborate with cross-functional teams to define, design, and ship new  \n   features. \n- Write clean, maintainable, and efficient code while adhering to best \n   practices. \n- Troubleshoot and debug applications to optimize performance and user \n   experience.\n- Participate in code reviews and provide constructive feedback to peers. \n- Stay updated with emerging technologies and industry trends to enhance \n   development processes. \n\n Qualifications:\n\n- Bachelor’s degree in Computer Science, Software Engineering, or a related  \n   field. \n- 2 to 5 years of professional experience in software development. \n- Proficiency in React.js and Node.js frameworks. \n- Strong understanding of RESTful APIs and web services. \n- Experience with version control systems, preferably Git. \n- Familiarity with database technologies such as MongoDB or PostgreSQL. \n\nPreferred Skills:\n\n- Knowledge of front-end build tools and package managers (e.g., Webpack,  \n   npm). \n- Experience with state management libraries (e.g., Redux, Context API). \n- Understanding of responsive design principles and mobile-first \n   development. \n- Familiarity with cloud services (e.g., AWS, Azure) and deployment \n   processes. \n- Strong problem-solving skills and ability to work in a fast-paced \n   environment. \n- Excellent communication and teamwork abilities.`;

      setJobDescription(defaultJD);
      setJD(defaultJD);
      localStorage.setItem("jobDescription", defaultJD);
    }
  }, []);

  const handleCreatePosition = (e) => {
    createJobDescription(formData);
    setIsSaved(false); // Mark as unsaved when JD is modified
  };

  const changeJobDescription = (e) => {
    setJobDescription(e.target.value);
    setJD(e.target.value);
    setIsSaved(false); // Mark as unsaved when JD is modified
  };

  function generateHashSession() {
    const now = new Date();

    // Format: YYYY-MM-DD_HH-MM-SS
    const timestamp = now.toISOString().replace(/[-:.TZ]/g, "_");

    // Generate a random number for uniqueness
    const randomPart = Math.floor(Math.random() * 1e12);

    return `${timestamp}_${randomPart}`;
  }

  const createJobDescription = async (data) => {
    const payload = {
      input_content: `Create a structured job description for the role of ${data.positionTitle}, specializing in ${data.technologies}, requiring ${data.minExperience}-${data.maxExperience} years of experience. Ensure the output includes only Key Responsibilities, Qualifications, and Preferred Skills, aligning with industry standards and clearly defining the required expertise.`,
      api_call: apiCall,
      hash_session: generateHashSession(),
    };
    try {
      setJobDescriptionLoader(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/fetch_jd`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );
      console.log(data?.technologies, "******Technologies*******");

      console.log("*******response*********", response);
      setJobDescription(response?.data?.job_description);
      localStorage.setItem("jobDescription", response?.data?.job_description);
      setJD(response?.data?.job_description);
      setApiCall(apiCall + 1);
      setJobDescriptionLoader(false);
      setMinExperience(data?.minExperience);
      setMaxExperience(data?.maxExperience);
      setTechnologies(data?.technologies);
      setPosition(data?.positionTitle);
    } catch (error) {
      setJobDescriptionLoader(false);
    } finally {
      setJobDescriptionLoader(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: value ? "" : "This field is required",
      }));
    }
    setIsSaved(false); // Mark as unsaved when JD is modified
  };

  const DownloadFile = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_KEY}/generate_pdf`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            text: jobDescription,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch the file");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "Job_Description.pdf";
      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error downloading the file:", error);
      toast.error("Error downloading the file:", {
        style: { backgroundColor: "red", color: "white" },
      });
    }
  };

  const AddJob = async () => {
    const payload = {
      job_title: formData.positionTitle,
      job_description: jD,
      required_skills: [formData.technologies],
      min_experience: formData.minExperience,
      max_experience: formData.maxExperience,
      // created_by_id: localStorage.getItem("user_id"),
      created_by_id: userID,
    };
    setJobDescriptionLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/add_job`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
        }
      );
      if (response.data && response.data.id) {
        const jobId = response.data.id; // Extract job ID from response
        setJobId(jobId);
        setIsSaved(true); // Mark as saved after successful job addition
        setIsSaveClicked(true);
        setShowSaved(true); // Show the saved state

        // Store jobId in state to display a shareable link
        setJobId(jobId);
        toast.success("Position created successfully!", {
          style: { backgroundColor: "green", color: "white" },
        });
      }
    } catch (error) {
      console.error("Error adding job:", error);
      toast.error(error.response?.data?.error, {
        style: { backgroundColor: "red", color: "white" },
      });
    } finally {
      setJobDescriptionLoader(false);
    }
  };

  const isFormValid = () => {
    return (
      formData.positionTitle?.trim() &&
      formData.technologies?.trim() &&
      formData.minExperience &&
      formData.maxExperience &&
      jobDescription?.trim()
    );
  };

  return (
    <>
      {jobDescriptionLoader && <Loading />}
      <div className="grid grid-cols-12 gap-6">
        <div
          className={
            "col-span-6 : col-span-12 bg-white shadow-xl rounded-2xl p-8"
          }
        >
          <h1 className="text-2xl font-bold text-blue-800 mt-4">
            Create Position
          </h1>
          <div className="grid grid-cols-2 gap-4 mt-4">
            {[
              { label: "Position Title", name: "positionTitle" },
              { label: "Technologies", name: "technologies" },
              {
                label: "Minimum Experience",
                name: "minExperience",
                type: "number",
                min: "0",
              },
              {
                label: "Maximum Experience",
                name: "maxExperience",
                type: "number",
                min: "0",
              },
            ].map(({ label, name, type = "text", min }) => (
              <div key={name}>
                <label className="block mb-1 text-gray-700">{label}*</label>
                <input
                  type={type}
                  name={name}
                  min={min}
                  value={formData[name] || ""}
                  onChange={handleChange}
                  className={`w-full p-3 border rounded-md focus:outline-none focus:ring-2 bg-inherit mt-2 ${
                    errors[name] ? "border-red-500" : "border-gray-300"
                  }`}
                />
                {errors[name] && (
                  <p className="text-red-500 text-sm mt-1">{errors[name]}</p>
                )}
              </div>
            ))}
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          className="bg-white shadow-xl rounded-lg p-6 col-span-6"
        >
          <h2 className="text-2xl font-bold text-blue-800 mt-4">
            Job Description
          </h2>
          <textarea
            className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50 mt-3"
            placeholder="Enter job description..."
            rows="10"
            value={
              jobDescriptionLoader
                ? "Generating Job Description through AI....."
                : jobDescription
                ? jobDescription
                : ""
            }
            onChange={changeJobDescription}
          ></textarea>
          <div className="flex gap-4 mt-4">
            <motion.button
              className="px-5 py-2 bg-blue-700 text-white rounded-lg shadow-md hover:bg-blue-800 transition flex items-center gap-2"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleCreatePosition}
            >
              <i class="fa-solid fa-bolt"></i>
              Generate AI Based Job Description
            </motion.button>

            <motion.button
              className="px-5 py-2 bg-blue-700 text-white rounded-lg shadow-md hover:bg-blue-800 transition flex items-center gap-2"
              onClick={() => {
                DownloadFile();
              }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <i class="fa-solid fa-cloud-arrow-down"></i>
              Download Job Description
            </motion.button>
          </div>
        </motion.div>
      </div>

      <div className="flex justify-center gap-3 mt-6 ">
        {/* {!jobId ? ( */}
        {!saved && (
          <motion.button
            className={`px-6 py-2 text-base rounded-lg shadow-md flex items-center gap-2 transition ${
              isFormValid()
                ? "bg-blue-700 text-white hover:bg-blue-800"
                : "bg-blue-600  text-white cursor-not-allowed"
            }`}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={AddJob}
            disabled={!isFormValid()}
          >
            <FaSave />
            Save
          </motion.button>
        )}
        {/* ) : (
          <div className="text-xl font-semibold">
            <a
              href={`http://localhost:3000/compare-resume?id=${jobId ?? ""}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white animate-pulse flex justify-center"
            >
              Click here to compare Job Description with Resume
            </a>
          </div>
        )} */}
      </div>
    </>
  );
};

export default CreatePositionTab;
